export default "__VITE_ASSET__BSNOwOrc__"